import React from 'react'
import { connect } from 'react-redux'
import JobAdContainer from 'components/job-ad-container'
import { mapLanguageToComponentProps } from 'careers/i18n'

interface JobAdProps {
  jobAd: {
    _id: string
    slug: string
  }
  company: { _id: string; slug: string }
  children?: React.ReactNode | React.ReactNode[] | null
}

const mapStateToProps = (state: any) => ({
  company: state.careers.company,
  jobAd: state.jobAd,
})

const JobAd = ({ company, jobAd, children }: JobAdProps) => {
  return (
    <JobAdContainer
      jobAd={jobAd}
      company={company}
      locationId="careersJobAdPage"
    >
      {children}
    </JobAdContainer>
  )
}

export default connect(mapLanguageToComponentProps(mapStateToProps))(JobAd)
